import React from "react";
import { Hero, Search, How, Options, Navbar, Footer } from "../../components";
import useDocumentTitle from "../../hooks/useDocumentTitle";
const Home: React.FC = () => {
  useDocumentTitle("ECOMOTO");

  return (
    <div className="bg-[#F6F7F9]">
      {/* <Navbar /> */}
      <Hero />
      <Search />
      <How />
      <Options />
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
